export const SponsorTiers = [
    "conch",
    "cone",
    "scallop",
    "sand_dollar",
    "in-kind"
];
